// 쿠키에 위치 정보를 저장하는 함수
import type { LocationData } from '@/app/_shared/store/type';
import { setCookie } from 'cookies-next/client';
import { CookieKey } from '@/app/(pages)/results/constants';

export const setCookieLocation = (location: Partial<LocationData>) => {
  if (typeof window === 'undefined') return;

  const expires = new Date();
  expires.setTime(expires.getTime() + 1000 * 60 * 10); // 10분

  setCookie(CookieKey.LOCATION, JSON.stringify(location), { expires });
};
